import React from 'react';
import './probability.css';
import Heading from '../../../../Miscs/Heading/Heading';

const Probability = () => {
	return (
		<>
			<div className="probability">
				<Heading>Probability</Heading>
			</div>
		</>
	);
};

export default Probability;
